import { render, staticRenderFns } from "./main-left-bar.vue?vue&type=template&id=529df358&scoped=true"
import script from "./main-left-bar.vue?vue&type=script&lang=js"
export * from "./main-left-bar.vue?vue&type=script&lang=js"
import style0 from "./main-left-bar.vue?vue&type=style&index=0&id=529df358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529df358",
  null
  
)

export default component.exports